import { USER_ROLE } from '../../constants';
import { get as lodashGet, set as lodashSet } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import classes from '../../styles/Bids.module.css';
import Table from '../../components/Table/Table';
import Typography from '../../components/Typography/Typography';
import { useLoader } from '../../hooks/use-loader.hook';
import ModalComponent from '../../components/ModalComponent/ModalComponent';
import { momentTimeFormater } from '../../utils/dateHelper';
import DeleteModalComponent from '../../components/DeleteModal/DeleteModal';
import { toast } from 'react-toastify';
import RequestOverview from './ModalComponent/RequestOverview';
import { DropdownComponent } from '../../components/Inputs/Input';
import { Capitalize } from '../../utils/stringHelper';
import CustomTooltip from '../../components/CustomToolTip/CustomTooltip';
import { UilInfoCircle, UilEye, UilPen, UilTrash } from '@iconscout/react-unicons';
import { CreateEditBidRequest } from './ModalComponent/CreateEditBidRequest';
import { BidRequestService } from '../../services/Bidding/BidRequest';
import IconComponent from '../../components/Icon/Icon';

const getInstanceHashMap = (instances = []) => {
    const hashMap = {};
    instances.forEach((ins) => {
        lodashSet(hashMap, [ins._id], ins);
    });
    return hashMap;
};

const RequestBid = ({ market, instance = [], licenseId, options = [], selectedOption, onChange, updateQueryParams, queryParamsData }) => {
    const { state } = useContext(AuthContext);
    const userRole = lodashGet(state, 'user.userRole');
    const [startLoader, stopLoader] = useLoader();
    const [instanceHashMap, setInstanceHashMap] = useState({});
    const [requests, setRequests] = useState([]);
    const [openRequestModal, setOpenRequestModal] = useState(false);
    const [editRequest, setEditRequest] = useState({});
    const [deleteModal, setDeleteModal] = useState({ status: false, id: '' });
    const [overviewModal, setoverviewModal] = useState({ status: false, request: {} });
    const [filterType, setFilterType] = useState(queryParamsData.filter ? queryParamsData.filter : { label: 'Current', value: 'current' });

    useEffect(() => {
        if (licenseId && Object.keys(instanceHashMap).length) fetchRequests();
    }, [licenseId, instanceHashMap, filterType]);

    useEffect(() => {
        updateQueryParams('filter', JSON.stringify(filterType));
    }, [filterType]);

    useEffect(() => {
        if (instance.length) {
            const groupsHash = getInstanceHashMap(instance);
            setInstanceHashMap(groupsHash);
        }
    }, [instance]);

    const fetchRequests = () => {
        const params = {
            filter: filterType?.value,
            licenseId,
            market,
        };
        BidRequestService.GetRequest(params, startLoader, handleFetchSuccess, handleError, stopLoader);
    };

    const openEditModal = (vals) => {
        setEditRequest(vals);
        setOpenRequestModal(true);
    };

    const closeCreateEditModal = (status) => {
        setOpenRequestModal(status);
        setEditRequest({});
    };

    const closeOverviewModal = (status) => {
        setoverviewModal({ status, request: {} });
    };

    const handleFetchSuccess = ({ data }) => {
        let processed = [];
        if (Array.isArray(data.data)) {
            processed = data.data.map((el) => ({
                ...el,
                startDate: momentTimeFormater(el.startDate).format('YYYY-MM-DD'),
                endDate: momentTimeFormater(el.endDate).format('YYYY-MM-DD'),
                createdAt: momentTimeFormater(el.createdAt).format('YYYY-MM-DD'),
                updatedAt: momentTimeFormater(el.updatedAt).format('YYYY-MM-DD'),
                instance: lodashGet(instanceHashMap, [el.instanceId, 'name']),
                status: el?.status ? Capitalize(el?.status) : '--',
                biddingMarket: el?.biddingMarket ? Capitalize(el?.biddingMarket) : '--',
                action: (
                    <div className={classes.ActionContainer}>
                        <div onClick={() => setoverviewModal({ status: true, request: el })}>
                            <IconComponent icon={UilEye} tooltip={'Update'} />
                        </div>

                        {el?.status === 'pending' && [USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) && (
                            <>
                                <div onClick={() => openEditModal(el)}>
                                    <IconComponent icon={UilPen} tooltip={'Delete'} />
                                </div>
                                <div onClick={() => setDeleteModal({ status: true, id: el._id })}>
                                    <IconComponent icon={UilTrash} tooltip={'Delete'} />
                                </div>
                            </>
                        )}
                        {el?.status === 'placed' && (
                            <>
                                <CustomTooltip content={'The request has been sent to Energinet, incase of any change reach out to us over email.'}>
                                    <UilInfoCircle size="1.2vw" />
                                </CustomTooltip>
                            </>
                        )}
                    </div>
                ),
            }));
        }
        setRequests(processed);
    };

    const handleDelete = (id) => {
        BidRequestService.DeleteRequest(id, startLoader, deleteSuccess, handleError, stopLoader);
    };

    const deleteSuccess = () => {
        toast.success('Bid request deleted successfully!');
        fetchRequests();
    };

    const handleError = (error) => {
        console.log(error);
    };

    return (
        <div className={classes.Bids}>
            <div className={classes.Header} style={{ marginTop: '1vw' }}>
                <div>
                    <Typography content="Request Bid" />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={requests.length} />
                        </span>
                    </div>
                    <div className={classes.InputContainer}>
                        <div className={classes.FieldControl2}>
                            <div style={{ minWidth: '10vw' }}>
                                <DropdownComponent
                                    name="license"
                                    options={options}
                                    defaultValue={selectedOption?.value ? selectedOption : options[0]}
                                    onChange={(e) => {
                                        if (e.value !== selectedOption?.value) onChange(e);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '0.5vw' }}>
                    <div className={classes.InputContainer}>
                        <div className={classes.FieldControl2}>
                            <div style={{ minWidth: '10vw' }}>
                                <DropdownComponent
                                    name="type"
                                    options={[
                                        { label: 'Current', value: 'current' },
                                        { label: 'Past', value: 'past' },
                                    ]}
                                    defaultValue={filterType}
                                    onChange={(e) => {
                                        if (e.value !== filterType?.value) {
                                            setFilterType(e);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={classes.ButtonsContainer}>
                        <div>
                            {[USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? (
                                <button
                                    onClick={() => {
                                        setOpenRequestModal(true);
                                    }}
                                    style={{ width: '7vw', margin: 0 }}
                                    className="btn-primary"
                                >
                                    Request
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <Table
                head={['Start Date', 'End Date', 'Created At', 'Updated At', 'Instance', 'Market', 'Status', 'Action']}
                keys={['startDate', 'endDate', 'createdAt', 'updatedAt', 'instance', 'biddingMarket', 'status', 'action']}
                data={requests}
            />
            <ModalComponent isOpen={openRequestModal} setOpen={closeCreateEditModal} style={{ maxHeight: '70vh', overflowY: 'scroll' }}>
                <CreateEditBidRequest
                    market={market}
                    instances={instance}
                    setOpen={closeCreateEditModal}
                    licenseId={licenseId}
                    editRequest={editRequest}
                    fetchRequests={fetchRequests}
                />
            </ModalComponent>
            <ModalComponent isOpen={overviewModal.status} setOpen={closeOverviewModal} style={{ maxHeight: '70vh', overflowY: 'scroll' }}>
                <RequestOverview market={market} request={overviewModal.request} setOpen={closeOverviewModal} />
            </ModalComponent>
            <DeleteModalComponent
                deletefunction={handleDelete}
                opendeleteModal={deleteModal.status}
                setOpenDeleteModal={(status) => setDeleteModal({ id: '', status })}
                deviceId={deleteModal.id}
            ></DeleteModalComponent>
        </div>
    );
};

export default RequestBid;
